import State from './interface';

export default <State>{
    visited: [],
};
